import moment from 'moment'
import { object, string } from 'yup'
import { isEmpty, isNil } from 'ramda'
import { emailRegExpFormat } from 'commons/email'
import { validatePhoneNumber } from 'app/componentV4/Input/PhoneNumberInput'

const TEXT_MAX = 40
const regex = /^\s*\p{L}/u

export const validationSchema = (countryCodes, formatMessage) => {
  const textRequired = formatMessage({
    id: 'error.form.required',
  })
  const phoneNumberInvalidText = formatMessage({
    id: 'memberForm.phoneNumberInvalid',
  })

  const { countryCode, automatedCallCountryCode } = countryCodes || {}
  return object({
    firstName: string()
      .required(formatMessage({ id: 'composeDialog.field.required' }))
      .max(
        TEXT_MAX,
        formatMessage(
          { id: 'maximum.characters.allowed' },
          { limit: TEXT_MAX },
        ),
      )
      .matches(regex, formatMessage({ id: 'validation.first.character' })),
    lastName: string()
      .required(formatMessage({ id: 'composeDialog.field.required' }))
      .max(
        TEXT_MAX,
        formatMessage(
          { id: 'maximum.characters.allowed' },
          { limit: TEXT_MAX },
        ),
      )
      .matches(regex, formatMessage({ id: 'validation.first.character' })),
    email: string()
      .transform((value) => value.trim())
      .matches(
        emailRegExpFormat,
        formatMessage({ id: 'memberForm.emailInvalid' }),
      ),
    countryCode: string(),
    phoneNumber: string().test(
      'is-valid-phone',
      phoneNumberInvalidText,
      (value, context) => {
        const { parent } = context
        const dialCode = parent.countryCode || ''
        const normalizedValue = value ? value.replace(dialCode, '') : ''
        return !normalizedValue || validatePhoneNumber(value, countryCode)
      },
    ),
    automatedCallPhoneNumber: string().test(
      'is-valid-phone',
      phoneNumberInvalidText,
      (value, context) => {
        const { parent } = context

        const automatedCallDialCode = parent.automatedCallCountryCode || ''

        const normalizedValue = value
          ? value.replace(automatedCallDialCode, '')
          : ''

        return (
          !normalizedValue ||
          validatePhoneNumber(value, automatedCallCountryCode)
        )
      },
    ),
    uniqueId: string()
      .nullable()
      .max(
        TEXT_MAX,
        formatMessage(
          { id: 'maximum.characters.allowed' },
          { limit: TEXT_MAX },
        ),
      ),
    preferChannel: string().required(textRequired),
    automatedCallCountryCode: string(),
    birthday: string().test(
      'birthdate-valid-date',
      formatMessage({ id: 'importCsv.validation.date.futureDate' }),
      (value) => {
        if (isEmpty(value) || isNil(value)) {
          return true
        }
        const date = moment(value)
        if (!date.isValid()) {
          return false
        } else {
          return date.isBefore(moment())
        }
      },
    ),
  })
}
